<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2026-07-06 13:58:37
 * @LastEditors: hl
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/detail/components/BottomBtn/index.vue
-->
<template>
  <div class="con">
    <!-- 有货时 -->
    <div v-if="true" class="pad_lr">
      <pharmacist />
      <!-- button -->
      <div class="btn_all">
        <div v-for="(item, index) in computedBtnList" :key="index">
          <div
            v-if="item.name"
            :class="{ buy_now: item.isLightHeight, colof: item.isLightHeight }"
            class="font14 font_weight500 add_cart color_primary"
            @click="clickBtn(item.name)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const Pharmacist = () =>
  import("@/components/Pharmacist").then(m => m.default || m);

export default {
  components: {
    Pharmacist
  },
  props: {
    btnList: {
      type: Array,
      default() {
        return [];
      }
    },
    packageIndex: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    getUserOrder() {
      return this.$store.getters.getUserOrder;
    },
    allowBuyAgain() {
      const order = this.getUserOrder;
      if (!order) return false;
      return (
        [0, 1, 2, 9, 10].includes(order.kind) && order.buyAgainButtonShow !== 1
      );
    },
    computedBtnList() {
      const order = this.getUserOrder;
      if (!order) return [];

      const list = [];
      const status = order.status;
      const deliveryMode = order.deliveryMode;
      const afterType = order.afterType;

      // 1. 修改地址展示逻辑
      if (order.isAllowUpAddress && order.kind !== 7 && deliveryMode !== 0) {
        list.push({ name: "修改地址", isLightHeight: false });
      }

      // 2. 核心状态按钮控制
      // 待付款 (10)
      if (status === 10) {
        list.push({ name: "取消订单", isLightHeight: false });
        if (order.kind === 10) {
          // 代客下单
          list.push({ name: "分享订单", isLightHeight: false });
        }
        const hidePayButton = order.kind === 10 && order.isCrossBorderOrder;
        if (!hidePayButton) {
          list.push({ name: "去付款", isLightHeight: true });
        }
        return list;
      }

      // 待审核 (5)
      if (status === 5) {
        list.push({ name: "继续逛逛", isLightHeight: false });
        return list;
      }

      // 付款失败 / 审核失败 (-5)
      if (status === -5) {
        list.push({ name: "取消订单", isLightHeight: false });
        list.push({ name: "重新支付", isLightHeight: true });
        return list;
      }

      // 计算售后按钮 (非待付款且 afterType 符合要求时)
      let afterBtn = null;
      if (afterType === 2 && deliveryMode !== 2) {
        afterBtn = { name: "申请售后", isLightHeight: false };
      } else if (afterType === 1) {
        afterBtn = { name: "申请退款", isLightHeight: false };
      }

      // 待发货 (11), 待收货 (12), 退款中 (-9)
      if (status === 11 || status === 12 || status === -9) {
        if (afterBtn) {
          list.push(afterBtn);
        }
      }
      // 已完成 (13, 14)
      else if (status === 13 || status === 14) {
        if (afterBtn) {
          list.push(afterBtn);
        }
        list.push({ name: "删除订单", isLightHeight: false });
        if (this.allowBuyAgain) {
          list.push({ name: "再次购买", isLightHeight: true });
        }
      }
      // 已关闭 (所有 < 0 的状态，除了 -5 和 -9)
      else if (status < 0 && status !== -5 && status !== -9) {
        list.push({ name: "删除订单", isLightHeight: false });
        if (this.allowBuyAgain) {
          list.push({ name: "再次购买", isLightHeight: true });
        }
      }

      return list;
    }
  },
  methods: {
    clickBtn(name) {
      const { retailSubOrderList } = this.getUserOrder;
      let a = "";
      retailSubOrderList.forEach(item => {
        if (item.orderType === 1) {
          a = item.subOrderSn;
          return;
        }
      });
      this.$emit(
        "clickBtn",
        name,
        this.getUserOrder.orderSn,
        this.packageIndex,
        this.item.subOrderSn || a,
        this.item.spuId
      );
    }
  }
};
</script>

<style lang="less" scoped>
.con {
  background: #fff;
  margin-top: 12px;
  box-shadow: 0px -3px 6px -3px rgba(193, 200, 207, 0.5);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  .icon_list {
    padding-left: 4px;
    .left_icon {
      width: 24px;
      height: 24px;
    }
  }
  .buy_now {
    background: linear-gradient(180deg, #e8caa1 0%, #bf9264 100%);
    box-shadow: -1px -1px 4px 0px rgba(255, 255, 255, 0.5);
    border-radius: 16px;
    line-height: 32px;
    width: 88px;
    margin-left: 10px;
    margin-top: 3px;
    border: 0 !important;
  }
  .add_cart {
    box-sizing: border-box;
    border-radius: 21px;
    border: 1px solid #000;
    line-height: 28px;
    width: 88px;
    margin-top: 3px;
    margin-left: 10px;
    text-align: center;
    border-color: var(--primary-color);
  }
  .mr {
    padding-left: 22px;
  }
  .pad_lr {
    display: flex;
    justify-content: space-between;
    padding: 9px 12px 12px;
    box-shadow: 3px 0px 6px -3px rgba(193, 200, 207, 0.5);
  }
  .btn_all {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>
